import React from "react";
//#region types
import { TotalCellProps } from "models/propTypes/simpleTableProps";
//#endregion
//#region components
import useValueFormatter from "../../useValueFormatter";
import { TableCell } from "@mui/material";
//#endregion
import cssExports from "theme/styles/main.module.scss";
import clsx from "clsx";

const TotalCell: React.FC<TotalCellProps> = ({
  repeatColumnLength,
  showTotal,
  repeatPropertyKey,
  index,
  depth,
  row,
}) => {
  const { getFormattedValue } = useValueFormatter();

  const getTotalCellValue = () => {
    return [...Array(repeatColumnLength)].reduce(
      (prev: number, current: number, currentIndex: number) =>
        prev +
        (showTotal?.valueFormatter
          ? showTotal?.valueFormatter(row[repeatPropertyKey][currentIndex], index, depth, currentIndex, row)
          : row[repeatPropertyKey][currentIndex][showTotal!.key]),
      0
    );
  };

  return (
    <TableCell
      key={`tab-repeatCell-total`}
      className={clsx(
        cssExports.tableCell,
        cssExports.repeatTitleCell,
        cssExports.truncateString,
        cssExports.totalCell
      )}
      align="right"
    >
      {repeatPropertyKey && row[repeatPropertyKey] !== undefined
        ? showTotal.displayFormatter
          ? getFormattedValue(showTotal.displayFormatter(getTotalCellValue()))
          : getTotalCellValue()
        : ""}
    </TableCell>
  );
};

export default TotalCell;
